import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';

export const errorHandlerFactory = (): BugsnagErrorHandler => {
  return new BugsnagErrorHandler();
};
